const ProfitIcon = ()=>{
return (
<div className  = "flex flex-center rounded-full p-[0.4rem] bg-gray-300">
<svg width="35px" height="35px" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="#000000">
<g id="SVGRepo_bgCarrier" strokeWidth="0"/>
<g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
<g id="SVGRepo_iconCarrier"> <g id="Layer_2" dataname="Layer 2"> <g id="invisible_box" dataname="invisible box"> <rect width="48" height="48" fill="none"/> </g> <g id="Icons"> <g> <rect x="33" y="4" width="10" height="40" rx="2"/> <rect x="19" y="19" width="10" height="25" rx="2"/> <rect x="5" y="33" width="10" height="11" rx="2"/> </g> </g> </g> </g>
</svg>
</div>
)
}
export default ProfitIcon; 
